<div class="component">
  <div class="cont">
    <p class="text-major">Hi, i’m Lucas Cavalheiro and i’m a web developer based in Rio de Janeiro<p>
    <p class="text-minor">You can know more about my work by using the navigation bar above or you can just...</p>
    <button class="bt-l bt-blue bt-positioned" routerLink="/projects">Click here to start</button>
  </div>
</div>
